module.exports = __webpack_public_path__ + "static/RenuKundaliya-6fd0224a4993fa356fdd930edad62130.jpg";